import { useEffect, useMemo } from 'react';
import { useTabExpandProductDetail } from 'hooks/useTabExpandProduct';

import reactCSS from 'reactcss';

const styles = reactCSS({
  default: {
    empty: {
      brickcode: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      },
      brickcodeContainer: {
        height: '100%',
      },
    },
    divider: {
      productPrimary: {
        margin: '8px 0px',
      },
      metaData: {
        margin: '8px 0px',
      },
    },

    detail: {
      leftModule: {
        container: {
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        },
        content: {
          display: 'flex',
          height: 'inherit',
          flexDirection: 'column',
        },
      },
      rightModule: {
        container: {
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        },
        content: {
          display: 'flex',
          height: 'inherit',
          flexDirection: 'column',
        },
      },
    },
    modalEditForm: {
      moduleName: { fontSize: 16, color: '#6c757d' },
      searchProperties: { marginRight: 24, marginLeft: 6 },
    },
  },
});

export const useStyleProductDetailContainer = ({ brickCode }) => {
  const {
    isTabExpanded: isExpanded,
    productHeaderImageSize,
    toggleTabExpand,
    shrinkTab,
  } = useTabExpandProductDetail(false);

  const { productHeaderIndent, searchAdvanceModuleInFullModeIndent } =
    useMemo(() => {
      const productHeaderIndent = `${productHeaderImageSize?.width + 10}px`;
      const searchAdvanceModuleInFullModeIndent = `${Math.sqrt(
        Math.pow(productHeaderImageSize?.width, 2) - Math.pow(35, 2)
      )}px`;

      return {
        productHeaderIndent,
        searchAdvanceModuleInFullModeIndent,
      };
    }, [productHeaderImageSize]);

  useEffect(() => {
    return () => {
      //* turn off expand when leave page
      shrinkTab();
    };
  }, []);

  const dStyles = reactCSS({
    default: {
      productHeader: {
        imageWrap: {
          width: productHeaderIndent,
          position: 'absolute',
        },
      },
      propertyQueryLeft: {
        borderRadius: isExpanded ? 0 : 3,
        background: '#f2f2f2',
      },
      propertyQueryRight: {
        borderRadius: isExpanded ? 0 : 3,
        background: !brickCode ? (isExpanded ? '#f2f2f2' : 'none') : '#f2f2f2',
        ...(!brickCode && !isExpanded ? { padding: 0 } : {}),
      },

      productPrimary: {
        wrap: {
          flexFlow: 'nowrap',
        },
        content: {
          paddingLeft: isExpanded ? productHeaderIndent : 0,
          transition: 'all 0.3s',
          flex: 1,
        },
      },
    },
  });

  return {
    styles,
    dStyles,
    isExpanded,
    toggleTabExpand,
    productHeaderImageSize,
    searchAdvanceModuleInFullModeIndent,
  };
};
